/* @jsx mdx */
import React from 'react'
import { mdx } from '@mdx-js/react'

import { Cite, Slide, Heading, Text, Box, FlexBox, Image, Appear, Markdown } from "spectacle";
import {LeftContentRightContent, LeftCodeRightContent, LeftCodeRightMarkdown, LeftContentRightMarkdown, LeftCodeRightCode} from "components/layout";
import { npmStatsCore, npmStatsReact } from "./imagesLoader";

function MDXContentWrapperSlide0(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */




const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const TitleDummy = makeShortcode("TitleDummy");
const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    {
      /* prettier-ignore-start */
    }
    {
      /* prettier-ignore-end */
    }
    <TitleDummy mdxType="TitleDummy" />
    <div>
      <Heading size={2} mdxType="Heading">
    Is Redux Dead?
      </Heading>
      <Heading size={1} color={"tertiary"} mdxType="Heading">
    <b>NO!</b>
      </Heading>
    </div>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperSlide0.isMDXComponent = true;

function MDXContentWrapperSlide1(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */





const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h4>{`Redux - Alive and Well!`}</h4>
    <ul>
      <li parentName="ul">{`Around 45% of all React apps use Redux, and used with other frameworks too`}</li>
      <li parentName="ul">{`Rough estimates of React state management library market share:`}
        <ul parentName="li">
          <li parentName="ul">{`Redux: 45-50%`}</li>
          <li parentName="ul">{`Apollo: 15%`}</li>
          <li parentName="ul">{`XState: 8%`}</li>
          <li parentName="ul">{`MobX: 7%`}</li>
          <li parentName="ul">{`Redux Toolkit: 4.5% (overlaps with Redux)`}</li>
          <li parentName="ul">{`React Query and SWR: 2.5% each`}</li>
        </ul>
      </li>
      <li parentName="ul">{`Used in large projects like:`}
        <ul parentName="li">
          <li parentName="ul">{`Wordpress's "Project Gutenberg" editor`}</li>
          <li parentName="ul">{`Firefox DevTools`}</li>
          <li parentName="ul">{`Slack`}</li>
          <li parentName="ul">{`Twitter's modernized UI`}</li>
          <li parentName="ul">{`Spotify`}</li>
        </ul>
      </li>
      <li parentName="ul">{`Maintained by myself and Tim Dorr - not owned by Facebook`}</li>
    </ul>
    <h3>{`Redux will be around for a long time!`}</h3>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperSlide1.isMDXComponent = true;

function MDXContentWrapperSlide2(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */





const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h4>{`Redux - Alive and Well!`}</h4>
    <Image src={npmStatsCore} mdxType="Image" />
    <Image src={npmStatsReact} mdxType="Image" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperSlide2.isMDXComponent = true;

function MDXContentWrapperSlide3(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */





const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h4>{`Redux - Alive and Well!`}</h4>
    <br />
    <h5>{`"Redux is over-used"`}</h5>
    <ul>
      <li parentName="ul">{`Very true!`}</li>
      <li parentName="ul"><strong parentName="li">{`For `}<em parentName="strong">{`any`}</em>{` tool, consider `}<em parentName="strong">{`why`}</em>{` you are using it and what the tradeoffs are`}</strong></li>
      <li parentName="ul">{`Guidance:`}
        <ul parentName="li">
          <li parentName="ul"><a parentName="li" {...{
              "href": "https://changelog.com/posts/when-and-when-not-to-reach-for-redux"
            }}>{`When (and when not) to Reach for Redux`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "https://redux.js.org/faq/general#when-should-i-use-redux"
            }}>{`Redux FAQ: "When should I use Redux?"`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "https://redux.js.org/faq/organizing-state#do-i-have-to-put-all-my-state-into-redux-should-i-ever-use-reacts-setstate"
            }}>{`Redux FAQ: "Can I still use `}<inlineCode parentName="a">{`setState`}</inlineCode>{` in a Redux app?"`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "https://redux.js.org/tutorials/essentials/part-2-app-structure#component-state-and-forms"
            }}>{`Redux Essentials tutorial: mixing local and Redux state`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "https://react-community-tools-practices-cheatsheet.netlify.app/state-management/redux"
            }}>{`React Community Tools and Practices: State Management > Redux`}</a></li>
        </ul>
      </li>
      <li parentName="ul">{`Opinions of the Twitterati do not necessarily reflect what's going on elsewhere`}</li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperSlide3.isMDXComponent = true;

function MDXContentWrapperSlide4(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */





const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h4>{`Redux - Alive and Well!`}</h4>
    <br />
    <h5>{`"GraphQL can replace Redux"`}</h5>
    <ul>
      <li parentName="ul">{`GraphQL is definitely great for data fetching and caching`}
        <ul parentName="li">
          <li parentName="ul">{`If that's all you used Redux / React-Redux for, you probably didn't `}<em parentName="li">{`need`}</em>{` Redux`}</li>
        </ul>
      </li>
      <li parentName="ul">{`GraphQL is a protocol, but most people use a sophisticated client like Apollo, which provides caching and normalization`}
        <ul parentName="li">
          <li parentName="ul">{`Apollo v3 has some local client state capabilities built-in`}</li>
        </ul>
      </li>
      <li parentName="ul">{`Observations`}
        <ul parentName="li">
          <li parentName="ul">{`Does seem to work best if your full stack is GraphQL-centric`}</li>
          <li parentName="ul">{`Managing complex client state via GraphQL seems awkward`}</li>
          <li parentName="ul">{`GraphQL and Redux aren't exclusive - possible to use GraphQL protocol for fetching, and cache in Redux`}</li>
        </ul>
      </li>
      <li parentName="ul">{`Same goes for React-Query and SWR - focused on data fetching`}</li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperSlide4.isMDXComponent = true;

function MDXContentWrapperSlide5(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */





const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h4>{`Redux - Alive and Well!`}</h4>
    <br />
    <h5>{`"Redux will be replaced by React Context and Hooks"`}</h5>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Context API is a `}<em parentName="strong">{`Dependency Injection`}</em>{` system, not a `}<em parentName="strong">{`state management`}</em>{` system!`}</strong></li>
      <li parentName="ul">{`Context API is great for passing data to deeply nested components`}
        <ul parentName="li">
          <li parentName="ul">{`If that's all you used Redux / React-Redux for, you probably didn't `}<em parentName="li">{`need`}</em>{` Redux`}</li>
        </ul>
      </li>
      <li parentName="ul"><inlineCode parentName="li">{`useReducer`}</inlineCode>{` looks a lot like Redux, and works well with `}<inlineCode parentName="li">{`useContext`}</inlineCode></li>
      <li parentName="ul">{`Limitations:`}
        <ul parentName="li">
          <li parentName="ul">{`No DevTools or middleware`}</li>
          <li parentName="ul">{`Limits with context update patterns and performance`}</li>
        </ul>
      </li>
      <li parentName="ul">{`Not mutually exclusive!`}
        <ul parentName="li">
          <li parentName="ul">{`Use state hooks + Redux together, same as using Redux + component state`}</li>
          <li parentName="ul">{`React-Redux hooks API is simpler than `}<inlineCode parentName="li">{`connect`}</inlineCode>{` and enables new patterns`}</li>
        </ul>
      </li>
      <li parentName="ul">{`Definitive answers: `}<a parentName="li" {...{
          "href": "https://blog.isquaredsoftware.com/2021/01/context-redux-differences/"
        }}><strong parentName="a">{`Why React Context is Not a "State Management" Tool (and Why It Doesn't Replace Redux)`}</strong></a></li>
      <li parentName="ul">{`React Suspense `}<em parentName="li">{`will`}</em>{` make things tricky down the road - we'll see how it works out`}</li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperSlide5.isMDXComponent = true;

function MDXContentWrapperSlide6(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */





const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h4>{`Problem Space Evolution`}</h4>
    <ul>
      <li parentName="ul">{`2015: "predictable state updates"`}
        <ul parentName="li">
          <li parentName="ul">{`Flux was a response to event-driven libs like Backbone`}</li>
        </ul>
      </li>
      <li parentName="ul">{`2021: "data fetching and caching"`}
        <ul parentName="li">
          <li parentName="ul">{`Devs don't want to track loading state`}</li>
          <li parentName="ul">{`Just call `}<inlineCode parentName="li">{`loadSomethingForMe()`}</inlineCode>{` and get `}<inlineCode parentName="li">{`{isLoading, data, error}`}</inlineCode>{` automatically`}</li>
          <li parentName="ul">{`Examples: Apollo Client, React-Query, SWR, Urql`}</li>
        </ul>
      </li>
      <li parentName="ul"><strong parentName="li">{`More on this topic in a minute :)`}</strong></li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperSlide6.isMDXComponent = true;

function MDXContentWrapperSlide7(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */





const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h4>{`Redux - Alive and Well!`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`TL;DR`}</strong>{`: Context, `}<inlineCode parentName="li">{`useReducer`}</inlineCode>{`, Apollo+GraphQL, Suspense, etc, are useful tools that can overlap with some of the ways Redux is used,
but there's still many valid reasons to choose and use Redux / React-Redux:`}
        <ul parentName="li">
          <li parentName="ul">{`Predictable state updates`}</li>
          <li parentName="ul">{`Optimized render performance`}</li>
          <li parentName="ul">{`Keeping logic outside the React component tree`}</li>
          <li parentName="ul">{`Sharing logic across platforms`}</li>
          <li parentName="ul">{`Redux DevTools`}</li>
          <li parentName="ul">{`Middleware`}</li>
          <li parentName="ul">{`Ecosystem`}</li>
          <li parentName="ul">{`Customizability`}</li>
        </ul>
      </li>
      <li parentName="ul">{`Mark's posts on this question:`}
        <ul parentName="li">
          <li parentName="ul"><strong parentName="li"><a parentName="strong" {...{
                "href": "https://blog.isquaredsoftware.com/2018/03/redux-not-dead-yet"
              }}>{`Redux - Not Dead Yet!`}</a></strong></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "https://changelog.com/posts/when-and-when-not-to-reach-for-redux"
            }}><strong parentName="a">{`When (and when not) to Reach for Redux`}</strong></a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "https://blog.isquaredsoftware.com/2021/01/context-redux-differences/"
            }}><strong parentName="a">{`Why React Context is Not a "State Management" Tool (and Why It Doesn't Replace Redux)`}</strong></a></li>
        </ul>
      </li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperSlide7.isMDXComponent = true;

function MDXContentWrapperSlide8(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */





const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h4>{`Summary`}</h4>
    <ul>
      <li parentName="ul">{`Redux is a jack of all trades`}
        <ul parentName="li">
          <li parentName="ul">{`"A platform for developers to build customized state management for their use-cases, while being able to reuse things like the graphical debugger or middleware"`}</li>
          <li parentName="ul">{`Can be used for many different use cases (UI state, server caching, state machines, complex logic, other global state)`}</li>
          <li parentName="ul">{`Probably not "best" at any one use case, but flexible enough for any of them`}</li>
        </ul>
      </li>
      <li parentName="ul"><strong parentName="li">{`Identify what problems you actually have, and choose tools that solve those problems`}</strong>
        <ul parentName="li">
          <li parentName="ul">{`WIP idea: `}<a parentName="li" {...{
              "href": "https://github.com/markerikson/react-community-tools-practices-cheatsheet/discussions/1"
            }}>{`RFC discussion: "React Community Tools and Practices" site`}</a></li>
          <li parentName="ul">{`Goal: provide a summary of common tools, libraries, and practices in the React community, with advice on what problems each tool solves and when it `}<em parentName="li">{`may`}</em>{` make sense to use that tool`}</li>
          <li parentName="ul">{`Initial prototype: `}<a parentName="li" {...{
              "href": "https://react-community-tools-practices-cheatsheet.netlify.app/state-management/overview/"
            }}>{`https://react-community-tools-practices-cheatsheet.netlify.app/state-management/overview/`}</a></li>
        </ul>
      </li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperSlide8.isMDXComponent = true;

function MDXContentWrapperSlide9(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */





const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h4>{`"Modern Redux"`}</h4>
    <ul>
      <li parentName="ul">{`Redux usage patterns and APIs have changed considerably since 2019`}
        <ul parentName="li">
          <li parentName="ul">{`Redux Toolkit for writing Redux logic`}</li>
          <li parentName="ul">{`Immer for "mutating" immutable update logic in reducers`}</li>
          <li parentName="ul">{`React-Redux hooks API`}</li>
          <li parentName="ul">{`Simpler approaches for using Redux with TypeScript`}</li>
        </ul>
      </li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://redux.js.org/style-guide/style-guide"
        }}>{`Redux Style Guide recommended best practices`}</a>{`:`}
        <ul parentName="li">
          <li parentName="ul">{`Put Redux logic in single-file "slices" per feature`}</li>
          <li parentName="ul">{`Put as much logic as possible in reducers`}</li>
          <li parentName="ul">{`Model actions as "events", not "setters"`}</li>
        </ul>
      </li>
    </ul>
    <h5>{`The "Modern Redux" patterns we teach today are `}<em parentName="h5">{`much`}</em>{` easier to learn and use!`}</h5>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperSlide9.isMDXComponent = true;

function MDXContentWrapperNotes0(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */





const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperNotes0.isMDXComponent = true;

function MDXContentWrapperNotes1(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */





const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperNotes1.isMDXComponent = true;

function MDXContentWrapperNotes2(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */





const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperNotes2.isMDXComponent = true;

function MDXContentWrapperNotes3(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */





const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperNotes3.isMDXComponent = true;

function MDXContentWrapperNotes4(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */





const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperNotes4.isMDXComponent = true;

function MDXContentWrapperNotes5(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */





const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperNotes5.isMDXComponent = true;

function MDXContentWrapperNotes6(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */





const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperNotes6.isMDXComponent = true;

function MDXContentWrapperNotes7(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */





const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperNotes7.isMDXComponent = true;

function MDXContentWrapperNotes8(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */





const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperNotes8.isMDXComponent = true;

function MDXContentWrapperNotes9(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */





const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperNotes9.isMDXComponent = true;


export const notes = [MDXContentWrapperNotes0,MDXContentWrapperNotes1,MDXContentWrapperNotes2,MDXContentWrapperNotes3,MDXContentWrapperNotes4,MDXContentWrapperNotes5,MDXContentWrapperNotes6,MDXContentWrapperNotes7,MDXContentWrapperNotes8,MDXContentWrapperNotes9];


export default [MDXContentWrapperSlide0,MDXContentWrapperSlide1,MDXContentWrapperSlide2,MDXContentWrapperSlide3,MDXContentWrapperSlide4,MDXContentWrapperSlide5,MDXContentWrapperSlide6,MDXContentWrapperSlide7,MDXContentWrapperSlide8,MDXContentWrapperSlide9]